/**
 * Created by Ibrahim Erata on 17.10.2017.
 */

export class BulkOperationsEvent {
  constructor(public isBulkOperationActive:boolean){}
}
